import { BrowserRouter as Router, Outlet, Route, Routes, Navigate } from "react-router-dom";
import { NavSider, NavBreadcrumb, Navbar } from "components";
import { Collapse, Layout, List, Modal, Popconfirm, Spin, Typography } from 'antd';
import { CloseCircleOutlined, LoadingOutlined, CloudDownloadOutlined } from "@ant-design/icons";
import axios from "axios";
import * as authActions from "store/actions/AuthActions";
import * as userActions from "store/actions/UserActions";
import { changeOrg } from "store/slices/AuthSlice";
import InstallPrompt from "components/Common/InstallPrompt";

// login
import Login from "./pages/Login/Login"

// clients
import Home from "./pages/Home/Home"

// clients
import Accounts from "./pages/Accounts/Accounts"
import AccountForm from "./pages/Accounts/AccountForm"
import AccountByNumber from "./pages/Accounts/AccountByNumber"
import AccountsParentPage from "pages/Accounts/AccountsParentPage";

// dasboard
import Dashboard from "./pages/Dashboard/Dashboard"

// employees
import Employees from "./pages/Employees/Employees"
import EmployeeForm from "./pages/Employees/EmployeeForm"
import EmployeeDetail from "./components/Employees/EmployeeDetail"
import EmployeesParentPage from "pages/Employees/EmployeesParentPage";

// contacts
import Contacts from "./pages/Contacts/Contacts"
import ContactForm from "./pages/Contacts/ContactForm"
import ContactsParentPage from "pages/Contacts/ContactsParentPage";

// expenses
import Expenses from "./pages/Expenses/Expenses"
import ExpenseForm from "./pages/Expenses/ExpenseForm"
import ImportExpenses from "./pages/Expenses/ImportExpenses"
import ExpenseCategories from "./pages/Expenses/ExpenseCategories"
import ExpensesParentPage from "pages/Expenses/ExpensesParentPage";

// invoices
import Invoices from "./pages/Invoices/Invoices"
import InvoiceForm from "./pages/Invoices/InvoiceForm"
import InvoicesParentPage from "pages/Invoices/InvoicesParentPage";

// contracts
import Contract from "pages/Contract/Contract";
import ContractType from "pages/Contract/ContractType";
import ContractTypeForm from "pages/Contract/ContractTypeForm";
import ContractEditor from "pages/Contract/ContractEditor";

// quotes
import Quotes from "./pages/Quotes/Quotes"
import QuoteForm from "./pages/Quotes/QuoteForm"
import QuotesParentPage from "pages/Quotes/QuotesParentPage";

// payments
import Payments from "./pages/Payments/Payments"
import ImportPayments from "./pages/Payments/ImportPayments"
import PaymentForm from "./pages/Payments/PaymentForm"
import PaymentsParentPage from "pages/Payments/PaymentsParentPage";

// payment links
import PaymentLinks from "./pages/PaymentLinks/PaymentLinks"
import PaymentLinksParentPage from "pages/PaymentLinks/PaymentLinksParentPage";

// credit notes
import CreditNotes from "./pages/CreditNotes/CreditNotes"
import CreditNoteForm from "./pages/CreditNotes/CreditNoteForm"
import CreditNotesParentPage from "pages/CreditNotes/CreditNotesParentPage";

// debit notes
import DebitNotes from "./pages/DebitNotes/DebitNotes"
import DebitNoteForm from "./pages/DebitNotes/DebitNoteForm"
import DebitNotesParentPage from "pages/DebitNotes/DebitNotesParentPage";

// users
import Users from "./pages/Users/Users"
import UserForm from "./pages/Users/UserForm"
import UsersParentPage from "pages/Users/UsersParentPage";

// settings
import Settings from "./pages/Settings/Settings"

// vendors
import Vendors from "./pages/Vendors/Vendors"
import VendorForm from "./pages/Vendors/VendorForm"
import ImportVendors from "./pages/Vendors/ImportVendors"
import VendorsParentPage from "pages/Vendors/VendorsParentPage";


// products
import Products from "./pages/Products/Products"
import ImportProducts from "./pages/Products/ImportProducts"
import ProductsParentPage from "pages/Products/ProductsParentPage";

import Documents from "pages/Documents/Documents";
import DocumentForm from "pages/Documents/DocumentForm";
import DocumentParentPage from "pages/Documents/DocumentParentPage";
import DocumentSigningPage from "pages/Documents/DocumentSigningPage";
import DocumentWorkflow from "pages/Documents/DocumentWorkflow";

// Public Document Access (no authentication required)
import PublicDocumentAccess from "pages/Public/PublicDocumentAccess";

// Link Redirect (public route)
import LinkRedirect from "pages/Links/LinkRedirect";




// Reports
import SalesReport from "./pages/Reports/SalesReport";
import LeadConversionReport from "./pages/Reports/LeadConversionReport";
import SalesPipelineReport from "./pages/Reports/SalesPipelineReport";
import AccountsReceivableReport from "./pages/Reports/AccountsReceivableReport";
import CustomerRevenueReport from "./pages/Reports/CustomerRevenueReport";
import ExpenseReport from "./pages/Reports/ExpenseReport";
import ProfitLossReport from "./pages/Reports/ProfitLossReport";
import DailyOperationsReport from "./pages/Reports/DailyOperationsReport";
import MonthlySalesReport from "./pages/Reports/MonthlySalesReport";
import EmployeePerformanceReport from "./pages/Reports/EmployeePerformanceReport";
import ReportsHub from "./pages/Reports/Reports";
import ReportViewer from "./pages/Reports/ReportViewer";

// Activity Templates
import ActivityTemplatesParentPage from "./pages/ActivityTemplates/ActivityTemplatesParentPage";
import ActivityTemplates from "./pages/ActivityTemplates/ActivityTemplates";

// Leads
import LeadsParentPage from "./pages/Leads/LeadsParentPage";
import Leads from "./pages/Leads/Leads";
import LeadForm from "./pages/Leads/LeadForm";
import ConvertLeadPage from "./pages/Leads/ConvertLeadPage";

// Campaigns
import CampaignParentPage from "./pages/Campaign/CampaignParentPage";
import Campaigns from "./pages/Campaign/Campaigns";
import CampaignForm from "./pages/Campaign/CampaignForm";

// Deals
import DealParentPage from "./pages/Deal/DealParentPage";
import Deals from "./pages/Deal/Deals";
import DealForm from "./pages/Deal/DealForm";

// Project Board
import ProjectBoardParentPage from "./pages/ProjectBoard/ProjectBoardParentPage";
import Overview from "./pages/ProjectBoard/Overview";
import Projects from "./pages/ProjectBoard/Projects";
import ProjectForm from "./pages/ProjectBoard/ProjectForm";
import ProjectView from "./pages/ProjectBoard/ProjectView";
import Tasks from "./pages/ProjectBoard/Tasks";
import TaskForm from "./pages/ProjectBoard/TaskForm";

// Support
import SupportParentPage from "./pages/Support/SupportParentPage";
import SupportOverview from "./pages/Support/SupportOverview";
import SupportTickets from "./pages/Support/SupportTickets";
import CreateTicket from "./pages/Support/CreateTicket";
import SupportTicketDetail from "./pages/Support/SupportTicketDetail";
import SupportApprovals from "./pages/Support/SupportApprovals";
import SupportKnowledgeBase from "./pages/Support/SupportKnowledgeBase";
import SupportSettings from "./pages/Support/SupportSettings";
import SupportAnalytics from "./pages/Support/SupportAnalytics";

// Assets
import AssetsParentPage from "./pages/Assets/AssetsParentPage";
import Assets from "./pages/Assets/Assets";
import AssetForm from "./pages/Assets/AssetForm";

// Links
import LinksParentPage from "./pages/Links/LinksParentPage";
import Links from "./pages/Links/Links";
import LinkForm from "./pages/Links/LinkForm";
import LinkCategories from "./pages/Links/LinkCategories";
import LinkCategoryForm from "./pages/Links/LinkCategoryForm";

// Communication Box - one inbox across WhatsApp and email
import CommunicationBox from "./pages/Communication/CommunicationBox";
import CommunicationParentPage from "./pages/Communication/CommunicationParentPage";

// WhatsApp

// Emails
import Emails from "./pages/Emails/Emails";
import EmailsParentPage from "./pages/Emails/EmailsParentPage";

// Reminders
import ReminderRules from "./pages/Reminders/ReminderRules";
import ReminderLogs from "./pages/Reminders/ReminderLogs";
import WhatsAppTemplates from "./pages/Reminders/WhatsAppTemplates";
import ReminderPreferences from "./pages/Reminders/ReminderPreferences";

import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import AssetFileParentPage from "pages/AssetFiles/AssetFileParentPage";
import AssetFiles from "pages/AssetFiles/AssetFiles";
import AssetFileForm from "pages/AssetFiles/AssetFileForm";
import NotFoundPage from "pages/NotFoundPage";
import AccessControl from "components/Access/AccessControl";
import NoAccess from "components/Access/NoAccess";
import InitiatePhonePe from "pages/PhonePe/InitiatePhonePe";
import TemplateParentPage from "pages/Template/TemplateParentPage";
import Templates from "pages/Template/Templates";
import TemplateForm from "pages/Template/TemplateForm";
import EditorViewer from "pages/Template/EditorViewer";

// My Profile
import MyProfile from "./pages/MyProfile/MyProfile";

// HR Modules
import LeaveManagementParentPage from "./pages/LeaveManagement/LeaveManagementParentPage";
import LeaveManagement from "./pages/LeaveManagement/LeaveManagement";
import WorkFromHomeParentPage from "./pages/WorkFromHome/WorkFromHomeParentPage";
import WorkFromHome from "./pages/WorkFromHome/WorkFromHome";
import AttendanceParentPage from "./pages/Attendance/AttendanceParentPage";
import Attendance from "./pages/Timesheet/Attendance";
import AttendanceForm from "./pages/Timesheet/AttendanceForm";
import AttendanceManager from "./pages/Timesheet/AttendanceManager";
import ImportAttendance from "./pages/Timesheet/ImportAttendance";
import MachineLogs from "./pages/Timesheet/MachineLogs";
import RunPayroll from "./pages/Payroll/RunPayroll";
import PayrollHistory from "./pages/Payroll/PayrollHistory";

// HR
import HRParentPage from "./pages/HR/HRParentPage";
import PerformanceReviews from "./pages/HR/PerformanceReviews";
import PerformanceReviewForm from "./pages/HR/PerformanceReviewForm";

// Accounting
import AccountingParentPage from "./pages/Accounting/AccountingParentPage";
import BankStatements from "./pages/Accounting/BankStatements";
import BankStatementsView from "./pages/Accounting/BankStatementsView";
import TransactionsView from "./pages/Accounting/TransactionsView";
import Budgets from "./pages/Accounting/Budgets";

// Events
import EventsParentPage from "./pages/Events/EventsParentPage";
import EventsPage from "./pages/Events/Events";

// Billing (provider-independent subscription billing)
import BillingParentPage from "./pages/Billing/BillingParentPage";
import BillingSubscriptions from "./components/Billing/BillingSubscriptions";
import BillingPlans from "./components/Billing/BillingPlans";
import BillingGateway from "./components/Billing/BillingGateway";

// Tenant Management
import TenantManagementParentPage from "pages/TenantManagement/TenantManagementParentPage";
import SaasProducts from "pages/TenantManagement/SaasProducts";
import SaasProductDetail from "pages/TenantManagement/SaasProductDetail";
import TMTenants from "pages/TenantManagement/Tenants";
import TenantCreate from "pages/TenantManagement/TenantCreate";
import TenantDetail from "pages/TenantManagement/TenantDetail";
import TenantSubscriptions from "pages/TenantManagement/TenantSubscriptions";
import TenantSubscriptionDetail from "pages/TenantManagement/TenantSubscriptionDetail";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.timeout = 30000; // 30 seconds timeout for all requests
// Acting organization (from .env) — billing endpoints use this when the auth
// token doesn't resolve an org server-side.
if (process.env.REACT_APP_ORGANIZATION_UUID) {
  axios.defaults.headers.common["X-Organization-Id"] = process.env.REACT_APP_ORGANIZATION_UUID;
}

const { Content, Footer } = Layout;

// Permission-to-route mapping in priority order (matches NavSider all_items order)
const dashboardFallbackRoutes = [
  { permissions: ['dashboard:view'], route: '/' },
  { permissions: ['reports:view'], route: '/reports' },
  { permissions: ['contacts:view'], route: '/contacts' },
  { permissions: ['communication:view'], route: '/communication' },
  { permissions: ['accounts:view'], route: '/accounts' },
  { permissions: ['leads:view'], route: '/leads' },
  { permissions: ['quotes:view'], route: '/quotes' },
  { permissions: ['deals:view'], route: '/deals' },
  { permissions: ['invoices:view'], route: '/invoices' },
  { permissions: ['payments:view'], route: '/payments' },
  { permissions: ['campaigns:view'], route: '/campaigns' },
  { permissions: ['accounting:view', 'expenses:view'], route: '/expenses' },
  { permissions: ['projects:view'], route: '/projects/overview' },
  { permissions: ['support:view'], route: '/support/tickets' },
  { permissions: ['hr:performance_reviews'], route: '/hr/performance-reviews' },
  { permissions: ['attendance:view'], route: '/attendance' },
  { permissions: ['leaves_management:view'], route: '/leave-management' },
  { permissions: ['work_from_home:view'], route: '/work-from-home' },
  { permissions: ['payroll:view'], route: '/payroll/run' },
  { permissions: ['links:view'], route: '/links' },
  { permissions: ['employees:view'], route: '/employees' },
  { permissions: ['users:view'], route: '/users' },
  { permissions: ['tenant_management:view'], route: '/tenant-management/saas-products' },
  { permissions: ['myprofile:view'], route: '/myprofile' },
];

const getDefaultRoute = (userPermissions) => {
  for (const item of dashboardFallbackRoutes) {
    if (item.permissions.some(p => userPermissions?.includes(p))) {
      return item.route;
    }
  }
  return '/myprofile';
};

const DashboardGuard = ({ user, defaultRoute, children }) => {
  // If user has a role-based default route (from backend), redirect to it
  if (defaultRoute && defaultRoute !== '/') {
    return <Navigate to={defaultRoute} replace />;
  }
  // Default route is '/' - show dashboard if user has permission
  if (user?.user_permissions?.includes('dashboard:view')) {
    return children;
  }
  // Fallback: find first accessible route from permissions
  const fallback = getDefaultRoute(user?.user_permissions);
  return <Navigate to={fallback} replace />;
};

const Routers = () => {
  const isAuthenticated = useSelector(
    (state) => state.auth.isAuthenticated
  );

  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const defaultRoute = useSelector((state) => state.auth.defaultRoute);

  if (token) {
    axios.defaults.headers.common["Authorization"] = "Token " + token;
  } else {
    axios.defaults.headers.common["Authorization"] = null;
  }

  const tasks = useSelector(
    (state) => state.general.tasks
  )

  const organization = useSelector(state => state.auth.organization);
  const [navDrawerOpen, setNavDrawerOpen] = useState(false);
  const [sessionModalOpen, setSessionModalOpen] = useState(false);
  const [sessionTimeout, setSessionTimeout] = useState(10);
  const sessionTimeoutRef = useRef(sessionTimeout);
  const dispatch = useDispatch();

  // Timeout function
  let authTimeout;

  let sessionTimeoutVar;

  const setSessionCountTimeout = () => {
    // setInterval(() => {
    //   setSeconds(prevSeconds => prevSeconds + 1);
    // }, 1000);
    sessionTimeoutVar = setInterval(() => {
      // dispatch(authActions.logout());
      // setSessionModalOpen(true);
      if (sessionTimeoutRef.current === 0) {
        clearInterval(sessionTimeoutVar);
        clearTimeout(authTimeout);
        // setSessionTimeout(10);
        dispatch(authActions.logout())
        setSessionModalOpen(false);

        // window.location.href = "/";
      } else {
        setSessionTimeout(prevSessionTimeout => prevSessionTimeout - 1);
        // alert(sessionTimeout);
      }
    }, 1000); // 5 minutes in milliseconds
  };

  const setAuthenticationTimeout = () => {
    authTimeout = setTimeout(() => {
      // dispatch(authActions.logout());
      setSessionModalOpen(true);
      setSessionCountTimeout();
      clearTimeout(authTimeout);
    }, 1 * 10 * 1000); // 5 minutes in milliseconds
  };

  const resetAuthenticationTimeout = () => {
    clearTimeout(authTimeout);
    setAuthenticationTimeout();
  };

  useEffect(() => {
    // Update ref whenever sessionTimeout changes
    sessionTimeoutRef.current = sessionTimeout;
  }, [sessionTimeout]);

  useEffect(() => {
    // Auto-load the single organization when authenticated
    const loadSingleOrganization = async () => {
      if (isAuthenticated && !organization) {
        try {
          const orgsData = await authActions.loadOrganizations();
          if (orgsData && orgsData.length > 0) {
            // Automatically select the first (and only) organization
            dispatch(changeOrg(orgsData[0].id));
          }
        } catch (error) {
          console.error("Error loading organization:", error);
        }
      }
    };

    loadSingleOrganization();
    // resetAuthenticationTimeout();
    // dispatch(authActions.check_token_validity());
  }, [isAuthenticated, organization, dispatch])

  useEffect(() => {
    // if (!isAuthenticated) {
    //   clearTimeout(authTimeout);
    // } else {
    //   resetAuthenticationTimeout();
    // }
  }, [isAuthenticated])



  useEffect(() => {
    // const interval = setInterval(() => {
    //   // process_tasks();
    //   fetchTasks();
    // }, 10000);

    // return () => {
    //   // Clear the interval when the component is unmounted to avoid memory leaks
    //   clearInterval(interval);
    //   if (sessionTimeoutVar) {
    //     clearInterval(sessionTimeoutVar);
    //   }
    // };
  }, [])


  return (
    <>
      <InstallPrompt />
      <Router>
        <Routes>
          {isAuthenticated && <Route path="" element={
            <Layout
              style={{
                height: '100vh',
              }}
            >
              <NavSider
                mobileOpen={navDrawerOpen}
                onMobileClose={() => setNavDrawerOpen(false)}
              />
              <Layout className="site-layout">
                <Navbar onMenuClick={() => setNavDrawerOpen(true)} />
                <Content
                  className="app-content"
                  style={{
                    margin: '0',
                    maxHeight: '100vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  <div style={{
                    margin: "10px"
                  }}>
                    <NavBreadcrumb />
                  </div>
                  <Outlet />
                </Content>
                <Footer
                  style={{
                    // color:"white",
                    // backgroundColor:"grey",
                    // marginTop: "5px",
                    textAlign: 'center',
                  }}
                >
                  Teson CRM © {new Date().getFullYear()} Created by Teson LLP
                </Footer>
              </Layout>
            </Layout>
          }>
            <Route
              path=""
              element={
                <DashboardGuard user={user} defaultRoute={defaultRoute}>
                  <Dashboard />
                </DashboardGuard>
              }
            >
            </Route>
            <Route
              path="home"
              element={<Home />}
            >
            </Route>
            <Route path="accounts" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["accounts:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="accounts:view" />
                )}
              >
                <AccountsParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Accounts />}
              ></Route>
              <Route
                path="new"
                element={<AccountForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<AccountForm />}
              >
              </Route>
              {/* Stable link for other systems, which record the account
                  number a person can read rather than the UUID. */}
              <Route
                path="by-number/:accountNumber"
                element={<AccountByNumber />}
              >
              </Route>
            </Route>
            <Route path="vendors" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["vendors:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="vendors:view" />
                )}
              >
                <VendorsParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Vendors />}
              ></Route>
              <Route
                path="new"
                element={<VendorForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<VendorForm />}
              >
              </Route>
              <Route
                path="import"
                element={<ImportVendors />}
              >
              </Route>
            </Route>
            <Route path="payments" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["payments:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="payments:view" />
                )}
              >
                <PaymentsParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Payments />}
              ></Route>
              <Route
                path="new"
                element={<PaymentForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<PaymentForm />}
              >
              </Route>
              <Route
                path="import"
                element={<ImportPayments />}
              >
              </Route>
            </Route>
            <Route path="payment-links" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["payments:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="payments:view" />
                )}
              >
                <PaymentLinksParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<PaymentLinks />}
              ></Route>
            </Route>
            <Route path="expenses" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["expenses:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="expenses:view" />
                )}
              >
                <ExpensesParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Expenses />}
              ></Route>
              <Route
                path="new"
                element={<ExpenseForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<ExpenseForm />}
              >
              </Route>
              <Route
                path="import"
                element={<ImportExpenses />}
              >
              </Route>
              <Route
                path="categories"
                element={<ExpenseCategories />}
              >
              </Route>
            </Route>
            <Route path="invoices" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["invoices:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="invoices:view" />
                )}
              >
                <InvoicesParentPage />
              </AccessControl>}>
              <Route
                path=""
                element={<Invoices />}
              ></Route>
              <Route
                path="new"
                element={<InvoiceForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<InvoiceForm />}
              >
              </Route>
            </Route>
            <Route path="credit-notes" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["credit_notes:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="credit_notes:view" />
                )}
              >
                <CreditNotesParentPage />
              </AccessControl>}>
              <Route
                path=""
                element={<CreditNotes />}
              ></Route>
              <Route
                path="new"
                element={<CreditNoteForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<CreditNoteForm />}
              >
              </Route>
            </Route>
            <Route path="debit-notes" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["debit_notes:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="debit_notes:view" />
                )}
              >
                <DebitNotesParentPage />
              </AccessControl>}>
              <Route
                path=""
                element={<DebitNotes />}
              ></Route>
              <Route
                path="new"
                element={<DebitNoteForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<DebitNoteForm />}
              >
              </Route>
            </Route>
            <Route path="quotes" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["quotes:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="quotes:view" />
                )}
              >
                <QuotesParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Quotes />}
              ></Route>
              <Route
                path="new"
                element={<QuoteForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<QuoteForm />}
              >
              </Route>
            </Route>
            <Route path="products" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["products:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="products:view" />
                )}
              >
                <ProductsParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Products />}
              ></Route>
              <Route
                path="import"
                element={<ImportProducts />}
              >
              </Route>
            </Route>
            <Route path="employees" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["employees:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="employees:view" />
                )}
              >
                <EmployeesParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Employees />}
              ></Route>
              <Route
                path="new"
                element={<EmployeeForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<EmployeeDetail />}
              >
              </Route>
            </Route>
            <Route path="contacts" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["contacts:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="contacts:view" />
                )}
              >
                <ContactsParentPage />
              </AccessControl>}
            >
              <Route
                path=""
                element={<Contacts />}
              ></Route>
              <Route
                path="new"
                element={<ContactForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<ContactForm />}
              >
              </Route>
            </Route>

            <Route path="contract" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["contracts:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="contracts:view" />
                )}
              >
                <Contract />
              </AccessControl>}
            >
            </Route>

            <Route path="contract/edit/:id" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["contracts:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="contracts:view" />
                )}
              >
                <ContractEditor />
              </AccessControl>}
            >
            </Route>

            <Route path="contract-type" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["contracts:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="contracts:view" />
                )}
              >
                <ContractType />
              </AccessControl>}
            >
              <Route
                path=""
                element={<ContractType />}
              ></Route>
              <Route
                path="new"
                element={<ContractTypeForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<ContractTypeForm />}
              >
              </Route>
            </Route>

            <Route path="documents" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["documents:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="documents:view" />
                )}
              >
                <DocumentParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Documents />}
              ></Route>
              <Route
                path="new"
                element={<DocumentForm />}
              >
              </Route>
              <Route
                path="sign/:id"
                element={<DocumentSigningPage />}
              >
              </Route>
              <Route
                path="workflow/:id"
                element={<DocumentWorkflow />}
              >
              </Route>
            </Route>
            <Route path="assetfiles" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["assetfiles:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="assetfiles:view" />
                )}
              >
                <AssetFileParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<AssetFiles />}
              ></Route>
              <Route
                path="new"
                element={<AssetFileForm />}
              >
              </Route>
            </Route>
            {/* NOTE: System Monitoring route removed */}
            {/* <Route path="systemmonitoring" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["systemmonitoring:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="systemmonitoring:view" />
                )}
              >
                <SystemMonitoring />
              </AccessControl>
            } /> */}
            <Route path="activity-templates" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["templates:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="templates:view" />
                )}
              >
                <ActivityTemplatesParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<ActivityTemplates />}
              ></Route>
              <Route
                path="email"
                element={<ActivityTemplates defaultTab="email" />}
              ></Route>
              <Route
                path="whatsapp"
                element={<ActivityTemplates defaultTab="whatsapp" />}
              ></Route>
              <Route
                path="batches"
                element={<ActivityTemplates defaultTab="batches" />}
              ></Route>
            </Route>
            <Route path="templates" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["templates:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="templates:view" />
                )}
              >
                <TemplateParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Templates />}
              ></Route>
              <Route
                path="new"
                element={<TemplateForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<TemplateForm />}
              >
              </Route>
              <Route
                path="editor"
                element={<EditorViewer />}
              >
              </Route>
            </Route>
            <Route path="users" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["users:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="users:view" />
                )}
              >
                <UsersParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Users />}
              ></Route>
              <Route
                path="new"
                element={<UserForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<UserForm />}
              >
              </Route>
            </Route>
            <Route path="reports" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <SalesReport />
              </AccessControl>
            }>
            </Route>
            <Route path="reports/all" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <ReportsHub />
              </AccessControl>
            } />
            <Route path="reports/view/:reportType" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <ReportViewer />
              </AccessControl>
            } />
            <Route path="reports/lead-conversion" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <LeadConversionReport />
              </AccessControl>
            } />
            <Route path="reports/sales-pipeline" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <SalesPipelineReport />
              </AccessControl>
            } />
            <Route path="reports/receivables" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <AccountsReceivableReport />
              </AccessControl>
            } />
            <Route path="reports/customer-revenue" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <CustomerRevenueReport />
              </AccessControl>
            } />
            <Route path="reports/expenses" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <ExpenseReport />
              </AccessControl>
            } />
            <Route path="reports/profit-loss" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <ProfitLossReport />
              </AccessControl>
            } />
            <Route path="reports/daily-operations" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <DailyOperationsReport />
              </AccessControl>
            } />
            <Route path="reports/monthly-sales" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <MonthlySalesReport />
              </AccessControl>
            } />
            <Route path="reports/employee-performance" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["reports:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="reports:view" />
                )}
              >
                <EmployeePerformanceReport />
              </AccessControl>
            } />
            <Route path="leads" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["leads:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="leads:view" />
                )}
              >
                <LeadsParentPage />
              </AccessControl>}>
              <Route
                path=""
                element={<Leads />}
              ></Route>
              <Route
                path="new"
                element={<LeadForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<LeadForm />}
              >
              </Route>
              <Route
                path="convert/:id"
                element={<ConvertLeadPage />}
              >
              </Route>
            </Route>
            <Route path="campaigns" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["campaigns:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="campaigns:view" />
                )}
              >
                <CampaignParentPage />
              </AccessControl>}>
              <Route
                path=""
                element={<Campaigns />}
              ></Route>
              <Route
                path="create"
                element={<CampaignForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<CampaignForm />}
              >
              </Route>
            </Route>
            <Route path="deals" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["deals:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="deals:view" />
                )}
              >
                <DealParentPage />
              </AccessControl>}>
              <Route
                path=""
                element={<Deals />}
              ></Route>
              <Route
                path="new"
                element={<DealForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<DealForm />}
              >
              </Route>
            </Route>
            <Route path="projects" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["projects:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="projects:view" />
                )}
              >
                <ProjectBoardParentPage />
              </AccessControl>}>
              <Route
                path="overview"
                element={<Overview />}
              ></Route>
              <Route
                path=""
                element={<Projects />}
              ></Route>
              <Route
                path="new"
                element={<ProjectForm />}
              ></Route>
              <Route
                path="edit/:id"
                element={<ProjectForm />}
              ></Route>
              <Route
                path="view/:id"
                element={<ProjectView />}
              ></Route>
            </Route>
            <Route path="tasks" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["tasks:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="tasks:view" />
                )}
              >
                <ProjectBoardParentPage />
              </AccessControl>}>
              <Route
                path=""
                element={<Tasks />}
              ></Route>
              <Route
                path="new"
                element={<TaskForm />}
              ></Route>
              <Route
                path="edit/:id"
                element={<TaskForm />}
              ></Route>
            </Route>
            <Route path="communication" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["communication:view", "templates:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="communication:view" />
                )}
              >
                <CommunicationParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={
                  <AccessControl
                    userPermissions={user?.user_permissions}
                    allowedPermissions={["communication:view"]}
                    renderNoAccess={() => (
                      <NoAccess permissionNeeded="communication:view" />
                    )}
                  >
                    <CommunicationBox />
                  </AccessControl>
                }
              ></Route>
              {/* The channel setup the inbox runs on: categories, templates and
                  the per-product email / WhatsApp configurations. Same page as
                  /activity-templates, which stays live so existing links work. */}
              <Route
                path="configuration"
                element={
                  <AccessControl
                    userPermissions={user?.user_permissions}
                    allowedPermissions={["templates:view"]}
                    renderNoAccess={() => (
                      <NoAccess permissionNeeded="templates:view" />
                    )}
                  >
                    <ActivityTemplates />
                  </AccessControl>
                }
              ></Route>
              <Route
                path="configuration/whatsapp"
                element={
                  <AccessControl
                    userPermissions={user?.user_permissions}
                    allowedPermissions={["templates:view"]}
                    renderNoAccess={() => (
                      <NoAccess permissionNeeded="templates:view" />
                    )}
                  >
                    <ActivityTemplates defaultTab="whatsapp-config" />
                  </AccessControl>
                }
              ></Route>
              <Route
                path="configuration/chatbot"
                element={
                  <AccessControl
                    userPermissions={user?.user_permissions}
                    allowedPermissions={["templates:view"]}
                    renderNoAccess={() => (
                      <NoAccess permissionNeeded="templates:view" />
                    )}
                  >
                    <ActivityTemplates defaultTab="chatbot-config" />
                  </AccessControl>
                }
              ></Route>
            </Route>
            {/* The old standalone WhatsApp screen is gone: numbers live in
                WhatsApp Configuration, templates in WhatsApp Templates, and
                conversations in the Communication Box. */}
            <Route path="whatsapp/*" element={<Navigate to="/communication/configuration/whatsapp" replace />} />
            <Route path="emails" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["emails:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="emails:view" />
                )}
              >
                <EmailsParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Emails />}
              ></Route>
            </Route>

            {/* Reminder Routes */}
            <Route path="reminders">
              <Route path="rules" element={<ReminderRules />} />
              <Route path="logs" element={<ReminderLogs />} />
              <Route path="whatsapp-templates" element={<WhatsAppTemplates />} />
              <Route path="preferences" element={<ReminderPreferences />} />
            </Route>

            {/* Assets Routes */}
            <Route path="assets" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["assets:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="assets:view" />
                )}
              >
                <AssetsParentPage />
              </AccessControl>}>
              <Route
                path=""
                element={<Assets />}
              ></Route>
              <Route
                path="new"
                element={<AssetForm />}
              >
              </Route>
              <Route
                path="edit/:id"
                element={<AssetForm />}
              >
              </Route>
            </Route>

            {/* Links Routes */}
            <Route path="links" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["links:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="links:view" />
                )}
              >
                <LinksParentPage />
              </AccessControl>
            }>
              <Route path="" element={<Links />} />
              <Route path="new" element={<LinkForm />} />
              <Route path="edit/:id" element={<LinkForm />} />
              <Route path="categories" element={<LinkCategories />} />
              <Route path="categories/new" element={<LinkCategoryForm />} />
              <Route path="categories/edit/:id" element={<LinkCategoryForm />} />
            </Route>

            {/* Support Routes */}
            <Route path="support" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["support:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="support:view" />
                )}
              >
                <SupportParentPage />
              </AccessControl>
            }>
              <Route index element={<SupportOverview />} />
              <Route path="overview" element={<SupportOverview />} />
              <Route path="tickets" element={<SupportTickets />} />
              <Route path="tickets/new" element={<CreateTicket />} />
              <Route path="tickets/:id" element={<SupportTicketDetail />} />
              <Route path="approvals" element={<SupportApprovals />} />
              <Route path="analytics" element={<SupportAnalytics />} />
              <Route path="knowledge-base" element={<SupportKnowledgeBase />} />
              <Route path="settings" element={<SupportSettings />} />
            </Route>

            <Route
              path="settings"
              element={
                <AccessControl
                  userPermissions={user?.user_permissions}
                  allowedPermissions={["settings:view"]}
                  renderNoAccess={() => (
                    <NoAccess permissionNeeded="settings:view" />
                  )}
                >
                  <Settings />
                </AccessControl>
              }
            >
            </Route>
            <Route path="leave-management" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["leaves_management:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="leaves_management:view" />
                )}
              >
                <LeaveManagementParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<LeaveManagement />}
              ></Route>
            </Route>
            <Route path="work-from-home" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["work_from_home:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="work_from_home:view" />
                )}
              >
                <WorkFromHomeParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<WorkFromHome />}
              ></Route>
            </Route>
            <Route path="attendance" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["attendance:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="attendance:view" />
                )}
              >
                <AttendanceParentPage />
              </AccessControl>
            }>
              <Route
                path=""
                element={<Attendance />}
              ></Route>
            </Route>
            <Route path="attendance/:mode" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["attendance:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="attendance:view" />
                )}
              >
                <AttendanceForm />
              </AccessControl>
            } />
            <Route path="attendance/:mode/:id" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["attendance:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="attendance:view" />
                )}
              >
                <AttendanceForm />
              </AccessControl>
            } />
            <Route path="timesheet/attendance-manager" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["attendance:manage"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="attendance:manage" />
                )}
              >
                <AttendanceManager />
              </AccessControl>
            } />
            <Route path="timesheet/import-attendance" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["attendance:import"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="attendance:import" />
                )}
              >
                <ImportAttendance />
              </AccessControl>
            } />
            <Route path="timesheet/machine-logs" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["machine_logs:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="machine_logs:view" />
                )}
              >
                <MachineLogs />
              </AccessControl>
            } />
            <Route path="payroll/run" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["payroll:run"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="payroll:run" />
                )}
              >
                <RunPayroll />
              </AccessControl>
            } />
            <Route path="payroll/history" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["payroll:history"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="payroll:history" />
                )}
              >
                <PayrollHistory />
              </AccessControl>
            } />

            {/* HR Routes */}
            <Route path="hr" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["hr:view", "hr:performance_reviews"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="hr:view" />
                )}
              >
                <HRParentPage />
              </AccessControl>
            }>
              <Route path="performance-reviews" element={<PerformanceReviews />} />
              <Route path="performance-reviews/new" element={<PerformanceReviewForm />} />
              <Route path="performance-reviews/edit/:id" element={<PerformanceReviewForm />} />
            </Route>

            {/* Accounting Routes */}
            <Route path="accounting" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["accounting:view", "expenses:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="accounting:view" />
                )}
              >
                <AccountingParentPage />
              </AccessControl>
            }>
              <Route path="bank-statements" element={<BankStatements />} />
              <Route path="bank-statements-view" element={<BankStatementsView />} />
              <Route path="transactions-view" element={<TransactionsView />} />
              <Route path="budgets" element={<Budgets />} />
            </Route>

            {/* Events Routes */}
            <Route path="events" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["events:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="events:view" />
                )}
              >
                <EventsParentPage />
              </AccessControl>
            }>
              <Route path="" element={<EventsPage />} />
            </Route>

            {/* Billing Routes (Subscriptions / Plans / Gateway) */}
            <Route path="billing" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["subscriptions:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="subscriptions:view" />
                )}
              >
                <BillingParentPage />
              </AccessControl>
            }>
              <Route path="" element={<Navigate to="subscriptions" replace />} />
              <Route path="subscriptions" element={<BillingSubscriptions />} />
              <Route path="plans" element={<BillingPlans />} />
              <Route path="gateway" element={<BillingGateway />} />
            </Route>

            {/* Tenant Management Routes */}
            <Route path="tenant-management" element={
              <AccessControl
                userPermissions={user?.user_permissions}
                allowedPermissions={["tenant_management:view"]}
                renderNoAccess={() => (
                  <NoAccess permissionNeeded="tenant_management:view" />
                )}
              >
                <TenantManagementParentPage />
              </AccessControl>
            }>
              <Route path="saas-products" element={<SaasProducts />} />
              <Route path="saas-products/:id" element={<SaasProductDetail />} />
              <Route path="tenants" element={<TMTenants />} />
              <Route path="tenants/new" element={<TenantCreate />} />
              <Route path="tenants/:id" element={<TenantDetail />} />
              <Route path="subscriptions" element={<TenantSubscriptions />} />
              <Route path="subscriptions/:id" element={<TenantSubscriptionDetail />} />
            </Route>

            <Route
              path="myprofile"
              element={<MyProfile />}
            >
            </Route>
          </Route>}
          <Route
            path=""
            element={<Login />}
          ></Route>
          <Route path="initiatePhonePe" element={<InitiatePhonePe />}>

          </Route>
          {/* Public Document Access Route - No Authentication Required */}
          <Route path="public/document/:token" element={<PublicDocumentAccess />} />
          {/* Link Redirect Route */}
          <Route path="l/:slug" element={<LinkRedirect />} />
          <Route
            path="*"
            element={<NotFoundPage />}
          ></Route>
        </Routes>
        {isAuthenticated && tasks.length > 0 && <div style={{ position: "fixed", bottom: 0, right: 0, zIndex: 100, backgroundColor: "#fff" }}>
          <Collapse
            expandIconPosition={'start'}
            style={{ width: "300px" }}
            // expandIcon={(props) =>
            //   <SettingOutlined
            //     onClick={(event) => {
            //       // If you don't want click extra trigger collapse, you can prevent this:
            //       event.stopPropagation();
            //     }}
            //   />
            // }
            items={[
              {
                key: '1',
                label: 'Preparing Download...',
                extra: <>
                  <Popconfirm
                    title="Cancel Task"
                    style={{ zIndex: 1000 }}
                    description="Once the tasks are cancelled, cannot be retrieve."
                    okText="Cancel Tasks"
                    cancelText="Continue Tasks"
                    onConfirm={() => {
                      dispatch(userActions.markCompleted({ ids: tasks.map(task => task.id) }))
                    }}
                    onOpenChange={() => console.log('open change')}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    <CloseCircleOutlined
                      onClick={(event) => {
                        // If you don't want click extra trigger collapse, you can prevent this:
                        event.stopPropagation();
                        // dispatch({ type: "CLEAR_TASKS" });
                      }}
                    />
                  </Popconfirm>
                </>,
                children: <List
                  // header={<div>Header</div>}
                  // footer={<div>Footer</div>}
                  dataSource={tasks}
                  renderItem={(item) => (
                    <List.Item>
                      <Typography.Text>{`${item.model} Export`}</Typography.Text> {item.status}
                      {item.status == "PENDING" && <Typography.Text><Spin
                        indicator={
                          <LoadingOutlined
                            style={{
                              fontSize: 24,
                            }}
                            spin
                          />
                        } /></Typography.Text>}
                      {item.status == "SUCCESS" && <Typography.Text><Spin
                        indicator={
                          <CloudDownloadOutlined style={{ fontSize: 24 }} onClick={async () => {
                            await userActions.downloadExportFileUsingChunks(item.id)
                          }} />
                        } /></Typography.Text>}
                    </List.Item>
                  )}
                />,
              },
            ]}
          />
        </div>}
      </Router>
      <Modal
        title="Do you want to continue logging in?"
        centered
        open={sessionModalOpen}
        onOk={() => {
          setSessionModalOpen(false)
          setSessionTimeout(10);
          clearInterval(sessionTimeoutVar);
          resetAuthenticationTimeout();
        }}
        okText={"Continue Logging In"}
        cancelText={"Logout"}
        onCancel={() => {
          setSessionModalOpen(false)
          dispatch(authActions.logout())
          window.location.href = "/";
        }}
      >
        <p>You will be logged out in {sessionTimeout} seconds.</p>
      </Modal>
    </>
  );
}
export default Routers;